import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/Button';
import Loading from '@/components/Loading';
import Input from '@/components/Input';
import { MdContentCopy, MdCheck } from 'react-icons/md';

interface InviteUrlModalProps {
  open: boolean;
  onClose: () => void;
  invitationUrl: string | null;
  isLoading?: boolean;
  errorMessage?: string | null;
}

export default function InviteUrlModal({
  open,
  onClose,
  invitationUrl,
  isLoading = false,
  errorMessage = null,
}: InviteUrlModalProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!invitationUrl) return;
    try {
      await navigator.clipboard.writeText(invitationUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // フォールバック: execCommand
      const textArea = document.createElement('textarea');
      textArea.value = invitationUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleClose = () => {
    setCopied(false);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          handleClose();
        }
      }}
    >
      <DialogContent className="w-[640px] rounded">
        <DialogHeader className="items-start space-y-0 px-lg! py-md!">
          <DialogTitle className="text-base font-bold">招待URL</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-md p-lg">
          {errorMessage && (
            <div className="rounded border border-solid border-danger bg-red-50 p-sm">
              <p className="text-body-sm text-danger">{errorMessage}</p>
            </div>
          )}

          {isLoading ? (
            <Loading size="small" />
          ) : (
            invitationUrl && (
              <div className="flex flex-col gap-xs">
                <div className="flex items-center gap-xs">
                  <div className="min-w-0 flex-[0_0_70%]">
                    <Input
                      value={invitationUrl}
                      readOnly
                      className="w-full text-sm"
                      onClick={(e) => (e.target as HTMLInputElement).select()}
                    />
                  </div>
                  <Button
                    type="button"
                    color={copied ? 'primary' : 'secondary'}
                    size="md"
                    onClick={handleCopy}
                    className="shrink-0"
                  >
                    {copied ? (
                      <>
                        <MdCheck className="size-4" />
                        コピー済み
                      </>
                    ) : (
                      <>
                        <MdContentCopy className="size-4" />
                        コピー
                      </>
                    )}
                  </Button>
                </div>
              </div>
            )
          )}
        </div>

        <DialogFooter className="justify-end gap-md px-lg! py-md!">
          <Button color="secondary" size="md" onClick={handleClose}>
            閉じる
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
